import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import styled from "styled-components";
import {systemApi} from "../../api/system-api";
import {Confirm} from "../../types/confirm";
import {DeviceOs} from "../../types/device/os";
import {UpdateVersionPayload} from "../../types/system/system";
import {validateUpdateVersionPayload} from "../../utils/validator/version";
import {ContainedYellowButton} from "../button/ContainedYellowButton";
import {BasicSingleSelector} from "../selector/BasicSingleSelector";
import {GeneralTextField} from "../text-field/GeneralTextField";

const DeviceOsMap: { [key: string]: DeviceOs } = {
    [DeviceOs.Android]: DeviceOs.Android,
    [DeviceOs.iOS]: DeviceOs.iOS,
};

const placeholder = {
    updateUrl: "업데이트 URL을 넣어주세요",
    forceUpdateVersionName: "1.0.0",
    versionName: "1.0.0",
};

const initUpdateVersionPayload: UpdateVersionPayload = {
    os: DeviceOs.Android,
    updateUrl: "",
    forceUpdateVersionName: "",
    versionName: "",
};

const initUpdateVersionPayloadValidator = {
    updateUrl: false,
    forceUpdateVersionName: false,
    versionName: false,
};

export const VersionForm = () => {
    const [updateVersionPayload, setUpdateVersionPayload] =
        useState<UpdateVersionPayload>(initUpdateVersionPayload);
    const [updateVersionPayloadValidator, setUpdateVersionPayloadValidator] =
        useState(initUpdateVersionPayloadValidator);
    const [selectedDeviceOs, setSelectedDeviceOs] = useState<DeviceOs>(
        DeviceOs.Android
    );

    const handleChangeTextField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setUpdateVersionPayload({
            ...updateVersionPayload,
            [event.target.name]: event.target.value,
        });
    };

    const handleClickSubmitButton = async () => {
        const {hasError, validationResults} =
            validateUpdateVersionPayload(updateVersionPayload);
        if (hasError) {
            setUpdateVersionPayloadValidator(validationResults);
            return;
        }
        try {
            await systemApi.updateVersion(updateVersionPayload);
            toast.success(Confirm.Confirm);
        } catch (error) {
            console.log("updateVersion error", error);
        }
        setUpdateVersionPayloadValidator(initUpdateVersionPayloadValidator);
    };

    const getVersionAsync = async () => {
        try {
            const response = await systemApi.getVersion({
                os: selectedDeviceOs,
            });
            setUpdateVersionPayload(response.data);
        } catch (error) {
            console.log("getVersionAsync error", error);
        }
    };

    const handleClickClientItem = (key: string) => {
        setSelectedDeviceOs(key as DeviceOs);
    };

    useEffect(() => {
        getVersionAsync();
    }, [selectedDeviceOs]);

    return (
        <VersionFormContainer>
            <VersionFormTitleContainer>
                <VersionFormTitleLabel>어플 버전 정보 수정</VersionFormTitleLabel>
            </VersionFormTitleContainer>

            <FlexRawContainer>
                <InputTitleLabel>업데이트 OS</InputTitleLabel>
                <BasicSingleSelector
                    value={DeviceOsMap[selectedDeviceOs]}
                    defaultKey={DeviceOsMap[DeviceOs.Android]}
                    candidateMap={DeviceOsMap}
                    onClickSelectItem={handleClickClientItem}
                    width="24.125rem"
                />
            </FlexRawContainer>

            <FlexRawContainer>
                <InputTitleLabel>업데이트 URL</InputTitleLabel>
                <GeneralTextField
                    placeholder={placeholder.updateUrl}
                    name={"updateUrl"}
                    value={updateVersionPayload.updateUrl}
                    onChange={handleChangeTextField}
                    width="24.125rem"
                    isError={updateVersionPayloadValidator.updateUrl}
                />
            </FlexRawContainer>

            <FlexRawContainer>
                <InputTitleLabel>강제 업데이트 버전</InputTitleLabel>
                <GeneralTextField
                    placeholder={placeholder.forceUpdateVersionName}
                    name={"forceUpdateVersionName"}
                    value={updateVersionPayload.forceUpdateVersionName}
                    onChange={handleChangeTextField}
                    width="24.125rem"
                    isError={updateVersionPayloadValidator.forceUpdateVersionName}
                />
            </FlexRawContainer>

            <FlexRawContainer>
                <InputTitleLabel>선택 업데이트 버전</InputTitleLabel>
                <GeneralTextField
                    placeholder={placeholder.versionName}
                    name={"versionName"}
                    value={updateVersionPayload.versionName}
                    onChange={handleChangeTextField}
                    width="24.125rem"
                    isError={updateVersionPayloadValidator.versionName}
                />
            </FlexRawContainer>

            <ButtonContainer>
                <ContainedYellowButton
                    width="8.188rem"
                    height="3.188rem"
                    text={"전송하기"}
                    onClick={handleClickSubmitButton}
                />
            </ButtonContainer>
        </VersionFormContainer>
    );
};

const VersionFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const VersionFormTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
`;

const VersionFormTitleLabel = styled.div`
  margin-top: 2px;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.375rem;
  color: rgb(0, 0, 0);
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
`;

const FlexRawContainer = styled.div`
  margin: 10px 0;
`;

const InputTitleLabel = styled.div`
  font-weight: 500;
  font-size: 0.813rem;
  line-height: 1rem;
  color: rgb(77, 83, 92);
  margin-bottom: 4px;
`;
